import React, { useState, useEffect } from "react"
import { FormControl, Select, MenuItem, Grid, Autocomplete, TextField, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useSelector } from "react-redux";
import "./style.css";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.register(ChartDataLabels);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function OverAllCo2tByScenarioChart(props) {
  //console.log("Over All cost-------------------------------", props.overAllCostData)
  console.log(props, "co22Data");

  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderData = useSelector(
    (state) => state.InputDataReducers.selectedFolderData
  );
  
  console.log(selectedFolderData, "selectedFolderData");
  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  
  const options = {
    plugins: {
      datalabels: {
        anchor: "end",
        align: "top",
        // color: "black",
        offset: -3,
        font: {
          weight: "bold",
          size: 12,
        },
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets?.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(dataset.data[context.dataIndex]);
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray?.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
      },
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      // tooltip:
      // {
      //     callbacks: {
      //         title: function(item){return item},
      //         label: function (tooltipItem) { console.log('ToolTip',tooltipItem);
      //             return tooltipItem + 'cr';},
      //     }
      // }
      // ,
      // tooltip: {
      //     callbacks: {
      //         title: function (e) {
      //             return ``;
      //         },
      //         label: function (tooltipItem) {
      //             let cost = datasets[tooltipItem.datasetIndex].data[0];
      //             let displayLabel = datasets[tooltipItem.datasetIndex].label + ': ';
      //             //return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //             return `${displayLabel}${NumberFormater(cost)} Cr }`;
      //         }
      //     }
      // }
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "S C E N A R I O",
        },
        barThickness: 8,
        barPercentage: 0.5,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        // beginAtZero: true,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Carbon Footprint ( in KG/Ton)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            return value.toString().substr(0, 6);
          },
        },

        stacked: true,
      },
    },
  };

  // const labels = ['Baseline', 'Scenario 1'];

  const [labels, setLabels] = useState([])
  useEffect(() => {
    if (props.overAllCo2Data?.length > 0) {
      const finalLabels = [];
      props.overAllCo2Data?.map((data) => {
        finalLabels.push(data?.chartname)
      });
      setLabels(finalLabels)
    }
  }, [props.overAllCo2Data])



  const temp1 = 5;
  const temp2 = 9;
  // const datasets = [
  //     {
  //         label: 'Outbound Production Cost',
  //         data: props.overAllCostData && props.overAllCostData.map((item) => item["Conversion Cost"]),
  //         backgroundColor: '#001f82'
  //     },
  //     {
  //         label: 'Inbound Transportation Cost',
  //         data: props.overAllCostData && props.overAllCostData.map((item) => item["Landed Cost"]),
  //         backgroundColor: '#00aaf4'
  //     },
  //     {
  //         label: 'Procurement Cost',
  //         data: props.overAllCostData && props.overAllCostData.map((item) => item["Pri Transportation Cost"]),
  //         backgroundColor: '#9c44c0'
  //     }
  // ];

  var datasets = [];

  const homedatasets = [
    {
      label: "Manufacturing CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map((item) => item["Manufacturing CO2"]),
      backgroundColor: "#FF9998",
    },
    {
      label: "Transportation CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map((item) => item["Transportation CO2"]),
      backgroundColor: "#FFEC9A",
    },
  ];

  console.log(homedatasets, "homedatasets1");
  // const nutritiondatasets = [
  //   {
  //     label: "Processing CO2",
  //     data:
  //       props.overAllCo2Data &&
  //       props.overAllCo2Data.map((item) => item["Processing CO2"]),
  //     backgroundColor: "#FF9998",
  //   },
  //   {
  //     label: "SFG transportation CO2",
  //     data:
  //       props.overAllCo2Data &&
  //       props.overAllCo2Data.map((item) => item["SFG transportation CO2"]),
  //     backgroundColor: "#A3E1D2",
  //   },
  //   {
  //     label: "Packaging CO2",
  //     data:
  //       props.overAllCo2Data &&
  //       props.overAllCo2Data.map((item) => item["Packaging CO2"]),
  //     backgroundColor: "#00B190",
  //   },
  //   {
  //     label: "Primary Transportation CO2",
  //     data:
  //       props.overAllCo2Data &&
  //       props.overAllCo2Data.map((item) => item["Primary Transportation CO2"]),
  //     backgroundColor: "#FFC000",
  //   },
  // ];

  const nutritiondatasets = [
    {
      label: "RMPM Transportation CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map((item) => item["RMPM Transportation CO2"]),
      backgroundColor: "#FF9998",
    },
    {
      label: "RMPM Procurement CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map((item) => item["RMPM Procurement CO2"]),
      backgroundColor: "#b8ffbd",
    },
    {
      label: "Processing CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map((item) => item["Processing CO2"]),
      backgroundColor: "#FFEC9A",
    },
    {
      label: "SFG transportation CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map(
          (item) => item["SFG transportation CO2"]
        ),
      backgroundColor: "#A3E1D2",
    },
    {
      label: "Packaging CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map((item) => item["Packaging CO2"]),
      backgroundColor: "#00B190",
    },

    {
      label: "Primary Transportation CO2",
      data:
        props.overAllCo2Data &&
        props.overAllCo2Data.map(
          (item) => item["Primary Transportation CO2"]
        ),
      backgroundColor: "#FFC000",
    },
  ];

  console.log(nutritiondatasets, "dataNutrition");
  console.log(
    props.overAllCo2Data.map((item) => item["Primary Transportation CO2"]),
    "hhg"
  );

  if (selectedCategoryId === 1) {
    datasets = homedatasets;
  } else {
    datasets = nutritiondatasets;
  }

  
  const labelTimePeriod = props.timePeriodOverAllCo2.label;
  const data01 = {
    labels: labelTimePeriod,
    datasets: props.timePeriodOverAllCo2.data,
  };

  const [selectedScenarios, setSelectedScenarios] = useState([])
  const handleChangeSelectScenario1 = (event, newSelected) => {
    if (newSelected?.length > 0) {

      setSelectedScenarios((prevSelected) => {
        const updatedSelected = [...prevSelected];
        const scenario = newSelected[newSelected?.length - 1];
    
        if (updatedSelected.some((item) => item.scenario === scenario.scenario)) {
          // Scenario is already selected, so deselect it
          const indexToRemove = updatedSelected.findIndex(
            (item) => item.scenario === scenario.scenario
          );
          updatedSelected.splice(indexToRemove, 1);
        } else {
          // Scenario is not selected, so add it
          updatedSelected.push(scenario);
        }
    
        return updatedSelected;
      });
      console.log(selectedScenarios, newSelected, "newSelected");
      // loadCharts(selectedInnerFolderId,newValue,selectScenario2Id);
    } else {
      setSelectedScenarios([])
    }
  }

  let uc = localStorage.getItem("selectedUsecase");
  let sr = localStorage.getItem("selectedRadio");
  const [shortTermStatus, setShortTermStatus] = useState(false);
  const [mediumTermStatus, setMediumTermStatus] = useState(false);
  useEffect(() => {
    if (uc === "Short Term") {
      if (sr === "masterData") {
        setShortTermStatus(true);
      } else {
        setShortTermStatus(false);
      }
    } else {
      if (sr === "masterData") {
        setMediumTermStatus(true);
      } else {
        setMediumTermStatus(false);
      }
    }
  }, [uc, sr]);
  console.log(uc, sr, shortTermStatus, mediumTermStatus, "statusss");
  const scenarioOptions = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Conversion CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Landed CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
  ];

  const nutritionScenarioOptions = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Procurement CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
  ];

  const nutritionScenarioOptions2 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  
  
   
   
  ];
  const nutritionScenarioOptions3 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Procurement CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
   

   
  ];
  const nutritionScenarioOptions4 = [
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
 
    
  ];
  const nutritionScenarioOptions5 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Procurement CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
  
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
 
   
   
   
  ];
  const nutritionScenarioOptions6 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation CO2",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging CO2",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation CO2",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
 
  
 
  
  ];


  let scenarioNames;
  
  if (folderModuleName === "module2") {
    scenarioNames = nutritionScenarioOptions2?.map(item => item.scenario);
  } else if (folderModuleName === "module3") {
    scenarioNames = nutritionScenarioOptions3?.map(item => item.scenario)
  } else if (folderModuleName === "module4") {
    scenarioNames = nutritionScenarioOptions4?.map(item => item.scenario)
  }else if (folderModuleName === "module5") {
    scenarioNames = nutritionScenarioOptions5?.map(item => item.scenario)
  }else if (folderModuleName === "module6") {
    scenarioNames = nutritionScenarioOptions6?.map(item => item.scenario)
  } else {
    scenarioNames = nutritionScenarioOptions?.map(item => item.scenario)

  }

//const scenarioNames = sr === "masterData" ? scenarioOptions?.map(item => item.scenario): nutritionScenarioOptions.map(item => item.scenario);

  const [selectedScenario, setSelectedScenario] = useState([]);
  console.log(selectedScenario, "seseesesee")

  const handleScenarioChange = (event) => {
    setSelectedScenario(event.target.value);
  };

  const handleClear = () => {
    setSelectedScenario([]);
  };

  
  const filterArray = [];
  if (selectedScenarios) {
      selectedScenarios.map((item) => {
          filterArray.push(item.scenario);
      })
  }
  console.log(filterArray, "filterArray");

  if (selectedScenario?.length > 0) {
      
      const maxDataLength = Math.max(...datasets?.map(item => item.data?.length));

      datasets?.forEach(item => {
          let isMatched = false;
          for (const filterString of selectedScenario) {
              if (item.label.toLowerCase().includes(filterString.toLowerCase())) {
                  isMatched = true;
                  break;
              }
          }
          if (!isMatched) {
              item.data = Array(maxDataLength).fill(0);
          }
      });

  }

  const baselineData = {
    // labels: props.data
    //   .sort((a, b) => (a.visit > b.visit ? 1 : -1))
    //   .map((item) => `Week ${item.visit}`),
    labels: labels,
    datasets,
  };

  const data = baselineData?.datasets;
  const sums = Array(data[0]?.data?.length).fill(0);

  data.forEach(item => {
    item?.data?.forEach((value, index) => {
      if (value !== null && value !== undefined) {
        sums[index] += value;
      }
    });
  });
  
  console.log(sums, "sm");

  console.log(props, "datayuyy");
  console.log(props.timePeriodOverAllCo2.data, "yyyyyy");
  console.log(baselineData, "baseline");
  const options01 = {
    plugins: {
      categoryPercentage: 0.4,
      barPercentage: 0.5,
      datalabels: {
        display: true,
        color: "black",
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(dataset.data[context.dataIndex]);
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray?.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
        anchor: "end",
        offset: -20,
        align: "start",
      },
      title: {
        display: false,
        // text: 'Chart.js Bar Chart - Stacked',
      },
      legend: {
        display: false,
      },

      tooltip: {
        callbacks: {
          title: function (item) {
            return item.title;
          },
          label: function (tooltipItem) {
            console.log("ToolTip", tooltipItem);
            //return tooltipItem.dataset.label + ': ' + tooltipItem.formattedValue + ' cr';},
            return (
              tooltipItem.dataset.cost +
              ":" +
              tooltipItem.dataset.label +
              " : " +
              tooltipItem.formattedValue
            );
          },
        },
      },
      // tooltip: {
      //     callbacks: {
      //         title: function (e) {
      //             return ``;
      //         },
      //         label: function (tooltipItem) {
      //             let cost = datasets[tooltipItem.datasetIndex].data[0];
      //             let displayLabel = datasets[tooltipItem.datasetIndex].label + ': ';
      //             //return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //             return `${displayLabel}${NumberFormater(cost)} Cr `;
      //         }
      //     }
      // }
    },
    responsive: true,
    barPercentage: 0.5,
    scales: {
      x: {
        maxBarThickness: 100,
        categoryPercentage: 0.4,
        barPercentage: 0.5,
        grid: {
          display: false,
          //drawBorder: false
        },
        title: {
          display: true,
          text: "T I M E  P E R I O D",
        },
        barThickness: 10, // number (pixels) or 'flex'
        // barPercentage: 10,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        categoryPercentage: 10,
        grid: {
          display: false,
          //drawBorder: false
        },
        title: {
          display: true,
          text: "Carbon Footprint ( in KG/Ton)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            return value.toString().substr(0, 6);
          },
        },
        stacked: true,
      },
    },
  };
  useEffect(() => {
    setSelectedScenario([]);
 }, [selectedFolderData])
 

  return (
    <>
      <div className="chart-block">
        <div className="chart-container">
          <div className="dropdown_container">
            <div className="pull-left"><h2>Carbon Footprint by Scenario (in KG/Ton)</h2></div>
            <div className="pull-right">
              <div className="pull-right">

              <div className="pull-right">
              <FormControl sx={{ m: 1, width: 300 }}>
              <InputLabel id="demo-multiple-checkbox-label">Filter By CO2</InputLabel>
              <Select
                id="scenario-multi-select"
                multiple
                value={selectedScenario}
                onChange={handleScenarioChange}
                input={
                  <OutlinedInput
                    label="Select Scenarios"
                    endAdornment={
                      selectedScenario?.length > 0 && (
                        <ClearIcon
                          style={{ cursor: 'pointer' }}
                          onClick={handleClear}
                        />
                      )
                    }
                  />
                }
                renderValue={(selected) => selected.join(', ')}
               
              >
                {scenarioNames?.map((scenario) => (
                  <MenuItem key={scenario} value={scenario}>
                    <Checkbox checked={selectedScenario.indexOf(scenario) > -1} />
                    <ListItemText primary={scenario} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              </div>              </div>
            </div>
          </div>
          <br />
          <div className="sum_container">
          {sums.map((item) => (
              <div>{item !==0 ? <div className="sum_container_items">{item.toFixed(2)}</div> : ""}</div>
       ))}
      </div>
          <Bar
            id="overall-co2-by-scenario"
            options={options}
            data={baselineData}
            height="100"
          />
        </div>
      </div>
      {/* <Grid item xs={7} md={7} lg={7} className="chart-block">
          <div className="chart-container">
            <h2>Carbon Footprint comparison split by time</h2>
            <Bar
              id="co2-comparison-split-by-time"
              data={data01}
              options={options01}
            />
          </div>
        </Grid> */}
    </>
  );
}

export default OverAllCo2tByScenarioChart;
